import '@/styles/globals.css';
import '@/styles/tailwind.css';
import 'tippy.js/dist/tippy.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { OpenAPI } from 'api-clients/monolith';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@/components/app';
import { ConfirmationProvider } from '@/components/base/confirmation';
import { ToasterProvider } from '@/components/base/toaster';
import { WxCopilotProvider } from '@/components/pages/wx-copilot-host/context';
import { AuthProvider } from '@/contexts/auth-context';
import LanguageProvider from '@/i18n/language-provider';
import { domainMeta } from '@/utils/domain-meta';

import { PostHogRootProvider } from './contexts/posthog-context';
import { RecommendationProvider } from './contexts/recommendation-context';


OpenAPI.BASE = domainMeta.monolithOrigin;
OpenAPI.WITH_CREDENTIALS = true;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // No need to retry 404s. Other calls should retry once, not more.
      retry: (failureCount, error): boolean => {
        if (failureCount >= 1) return false;
        return !error.message?.includes('Not Found');
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <PostHogRootProvider properties={{ product: 'hire', ui: 'source' }}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <LanguageProvider>
              <ToasterProvider>
                <ConfirmationProvider>
                    <WxCopilotProvider>
                      <RecommendationProvider>
                        <App />
                      </RecommendationProvider>
                    </WxCopilotProvider>
                </ConfirmationProvider>
              </ToasterProvider>
            </LanguageProvider>
          </AuthProvider>
        </QueryClientProvider>
      </PostHogRootProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
